import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useIsMobile from "../../../hooks/useIsMobile";
import { ItemGrid } from "./SubHeaderStyled";
import {
  getSubHeaderBannerBackground,
  getSubHeaderBannerMetrics,
} from "./subHeaderBannerStyles";

/**
 * Search-page banner shell: decorative ItemGrid marks, height, padding, gradient.
 * Same outer structure as V3SearchSubHeader / SubHeader list banners.
 */
export default function SubHeaderBannerShell({
  testId,
  children,
  background,
  marksMuted,
}) {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { minHeight, padding } = getSubHeaderBannerMetrics(isMobile);
  const bannerBackground = background ?? getSubHeaderBannerBackground(theme);

  return (
    <Grid
      container
      position="relative"
      alignItems="center"
      sx={{
        background: bannerBackground,
        minHeight,
      }}
      data-testid={testId}
      data-banner-background={background === "transparent" ? "transparent" : undefined}
    >
      <ItemGrid
        data-compact={isMobile ? "true" : undefined}
        data-muted={marksMuted ? "true" : undefined}
      >
        <Grid
          container
          flexDirection="column"
          justifyContent="center"
          style={{ padding }}
        >
          {children}
        </Grid>
      </ItemGrid>
    </Grid>
  );
}

SubHeaderBannerShell.propTypes = {
  testId: PropTypes.string,
  children: PropTypes.node,
  background: PropTypes.string,
  marksMuted: PropTypes.bool,
};

SubHeaderBannerShell.defaultProps = {
  testId: undefined,
  children: null,
  background: undefined,
  marksMuted: false,
};
